export const SET_CONFIGURATION = 'NFSE_CONFIGURATIONS/SET_CONFIGURATION';
